import { render, staticRenderFns } from "./BitrixIcon.vue?vue&type=template&id=54945b8f&"
import script from "./BitrixIcon.vue?vue&type=script&lang=ts&"
export * from "./BitrixIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports